import { render, staticRenderFns } from "./PalletLabel.vue?vue&type=template&id=64abd1c5&scoped=true"
import script from "./PalletLabel.vue?vue&type=script&lang=js"
export * from "./PalletLabel.vue?vue&type=script&lang=js"
import style0 from "./PalletLabel.vue?vue&type=style&index=0&id=64abd1c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64abd1c5",
  null
  
)

export default component.exports